var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false, title: "折旧计提" } },
        [
          _c(
            "div",
            {
              staticClass: "table-operator",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _vm.btnEnableList.indexOf("1") > -1
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "calculator" },
                      on: { click: _vm.openCalc },
                    },
                    [_vm._v("计提")]
                  )
                : _vm._e(),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { icon: "sync" },
                  on: { click: _vm.loadData },
                },
                [_vm._v("刷新")]
              ),
              _vm.btnEnableList.indexOf("3") > -1
                ? _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: { icon: "download" },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  staticStyle: { "margin-bottom": "12px" },
                  attrs: { layout: "inline" },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "期间" } },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "90px" },
                          attrs: {
                            value: _vm.queryParam.depYear,
                            placeholder: "年",
                          },
                          on: { change: (v) => _vm.setYear(v) },
                        },
                        _vm._l(_vm.yearOptions, function (y) {
                          return _c(
                            "a-select-option",
                            { key: y, attrs: { value: y } },
                            [_vm._v(_vm._s(y) + "年")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "80px", "margin-left": "4px" },
                          attrs: {
                            value: _vm.queryParam.depMonth,
                            placeholder: "月",
                          },
                          on: { change: (v) => _vm.setMonth(v) },
                        },
                        _vm._l(12, function (m) {
                          return _c(
                            "a-select-option",
                            { key: m, attrs: { value: m } },
                            [_vm._v(_vm._s(m) + "月")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "全部", "allow-clear": "" },
                          model: {
                            value: _vm.queryParam.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParam, "status", $$v)
                            },
                            expression: "queryParam.status",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "0" } }, [
                            _vm._v("未审核"),
                          ]),
                          _c("a-select-option", { attrs: { value: "1" } }, [
                            _vm._v("已审核"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "search" },
                          on: { click: _vm.searchQuery },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { icon: "reload" },
                          on: { click: _vm.searchReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.tableData,
              loading: _vm.loading,
              pagination: false,
              scroll: _vm.tableScroll,
            },
            scopedSlots: _vm._u([
              {
                key: "status",
                fn: function (text) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a-tag",
                        { attrs: { color: text === "1" ? "green" : "orange" } },
                        [_vm._v(_vm._s(text === "1" ? "已审核" : "未审核"))]
                      ),
                    ],
                    1
                  )
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openDetail(record)
                            },
                          },
                        },
                        [_vm._v("明细")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handlePrint(record)
                            },
                          },
                        },
                        [_vm._v("打印")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      record.status === "0"
                        ? [
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAudit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("审核")]
                                )
                              : _vm._e(),
                            _vm.canAudit(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSubmitFlow(record)
                                      },
                                    },
                                  },
                                  [_vm._v("提交审批")]
                                )
                              : _vm._e(),
                            _vm.canSubmitFlow(_vm.billPrefix(record.billNo))
                              ? _c("a-divider", { attrs: { type: "vertical" } })
                              : _vm._e(),
                            _c(
                              "a-popconfirm",
                              {
                                attrs: { title: "作废并删除该计提单?" },
                                on: { confirm: () => _vm.handleDelete(record) },
                              },
                              [
                                _c("a", { staticStyle: { color: "red" } }, [
                                  _vm._v("作废"),
                                ]),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "a-popconfirm",
                              {
                                attrs: {
                                  title: "反审核将冲销明细与凭证，确认?",
                                },
                                on: {
                                  confirm: () => _vm.handleUnaudit(record),
                                },
                              },
                              [_c("a", [_vm._v("反审核")])]
                            ),
                          ],
                    ],
                    2
                  )
                },
              },
            ]),
          }),
          _c("a-pagination", {
            staticStyle: { "margin-top": "12px", "text-align": "right" },
            attrs: {
              "show-size-changer": "",
              "show-quick-jumper": "",
              current: _vm.ipagination.current,
              "page-size": _vm.ipagination.pageSize,
              "page-size-options": _vm.ipagination.pageSizeOptions,
              total: _vm.ipagination.total,
            },
            on: {
              change: _vm.handleTableChange,
              showSizeChange: _vm.handleTableChange,
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "折旧计提",
            width: 960,
            visible: _vm.calcVisible,
            maskClosable: false,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.calcVisible = false
            },
          },
        },
        [
          _c(
            "a-form",
            {
              staticStyle: { "margin-bottom": "12px" },
              attrs: { layout: "inline" },
            },
            [
              _c(
                "a-form-item",
                { attrs: { label: "计提年" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "90px" },
                      model: {
                        value: _vm.calcForm.depYear,
                        callback: function ($$v) {
                          _vm.$set(_vm.calcForm, "depYear", $$v)
                        },
                        expression: "calcForm.depYear",
                      },
                    },
                    _vm._l(_vm.yearOptions, function (y) {
                      return _c(
                        "a-select-option",
                        { key: y, attrs: { value: y } },
                        [_vm._v(_vm._s(y) + "年")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "计提月" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "80px" },
                      model: {
                        value: _vm.calcForm.depMonth,
                        callback: function ($$v) {
                          _vm.$set(_vm.calcForm, "depMonth", $$v)
                        },
                        expression: "calcForm.depMonth",
                      },
                    },
                    _vm._l(12, function (m) {
                      return _c(
                        "a-select-option",
                        { key: m, attrs: { value: m } },
                        [_vm._v(_vm._s(m) + "月")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                [
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "eye",
                        loading: _vm.previewing,
                      },
                      on: { click: _vm.handlePreview },
                    },
                    [_vm._v("预览")]
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-left": "8px" },
                      attrs: {
                        type: "primary",
                        icon: "check",
                        loading: _vm.generating,
                        disabled: !_vm.previewData,
                      },
                      on: { click: _vm.handleGenerate },
                    },
                    [_vm._v("生成计提单")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.previewData
            ? [
                _c("a-alert", {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: {
                    type: "info",
                    "show-icon": "",
                    message:
                      `计提资产 ${_vm.previewData.assetCount} 台，折旧总额 ${
                        _vm.previewData.totalAmount || 0
                      }` +
                      (_vm.previewData.skipped && _vm.previewData.skipped.length
                        ? `；跳过 ${_vm.previewData.skipped.length} 台（提足/无工作量）`
                        : ""),
                  },
                }),
                _c("a-table", {
                  attrs: {
                    bordered: "",
                    size: "small",
                    rowKey: "assetId",
                    columns: _vm.previewColumns,
                    dataSource: _vm.previewData.items,
                    pagination: false,
                    scroll: { x: "max-content", y: 320 },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "workload",
                        fn: function (text, record) {
                          return [
                            record.method === 2
                              ? _c("a-input-number", {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    min: 0,
                                    precision: 2,
                                    placeholder: "录入工作量",
                                  },
                                  on: {
                                    change: () => _vm.markWorkload(record),
                                  },
                                  model: {
                                    value: record.workload,
                                    callback: function ($$v) {
                                      _vm.$set(record, "workload", $$v)
                                    },
                                    expression: "record.workload",
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2838185472
                  ),
                }),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "8px", color: "#999" } },
                  [
                    _vm._v(
                      "工作量法资产在预览表录入本期工作量后重新预览或直接生成；期间已结账将被拦截并提示。"
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: `计提单明细 ${_vm.detail.billNo || ""}`,
            width: 860,
            visible: _vm.detailVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.detailVisible = false
            },
          },
        },
        [
          _c(
            "a-descriptions",
            {
              staticStyle: { "margin-bottom": "8px" },
              attrs: { bordered: "", size: "small", column: 3 },
            },
            [
              _c("a-descriptions-item", { attrs: { label: "期间" } }, [
                _vm._v(
                  _vm._s(_vm.detail.depYear) + "-" + _vm._s(_vm.detail.depMonth)
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "资产数" } }, [
                _vm._v(_vm._s(_vm.detail.assetCount)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "折旧总额" } }, [
                _vm._v(_vm._s(_vm.detail.totalAmount)),
              ]),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "small",
              rowKey: "id",
              columns: _vm.detailColumns,
              dataSource: _vm.detail.details,
              pagination: false,
              scroll: { x: "max-content", y: 360 },
            },
          }),
        ],
        1
      ),
      _c("asset-bill-print", { ref: "assetPrint" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }